import { SUCCESS_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import displayModal from 'root/src/client/logic/modal/actions/displayModal'

export default ({ body: { email } }) => (dispatch) => {
	dispatch(displayModal(SUCCESS_MODAL_MODULE_ID, {
		header: 'Paypal account succesfully added',
		infoText: `Your payouts will be sent to paypal account connected to ${email}`,
	}))
}
